import { action } from "satcheljs";
import type { ClientItemId } from "owa-client-ids";
import type { FullComposeEntrySourceType } from "owa-calendar-helpers-types/lib/ComposeMetricTypes";
import type { UTActionSource } from "owa-calendar-unified-telemetry-utils/lib/schema/UTActionSource";

export interface LaunchCalendarFullComposeToDuplicateActionMessage {
    itemId: ClientItemId;
    entrySource: FullComposeEntrySourceType;
    utActionSource: UTActionSource;
}
export const launchCalendarFullComposeToDuplicate: (itemId: ClientItemId, entrySource: FullComposeEntrySourceType, utActionSource: UTActionSource) => LaunchCalendarFullComposeToDuplicateActionMessage = action("launchCalendarFullComposeToDuplicate", (itemId: ClientItemId, entrySource: FullComposeEntrySourceType, utActionSource: UTActionSource): LaunchCalendarFullComposeToDuplicateActionMessage => ({
    itemId,
    entrySource,
    utActionSource,
}));
